import React from 'react';
import CustomerBureau from 'components/Tvendo/Sale/DataMaster/CustomerBureau/List.js';

export default function () {
  return <CustomerBureau />;
}
